module.exports = __webpack_public_path__ + "img/TWS-Houston-logo.ba20f51f.png";